export const SPORTFOLIO_IPO_ABI = [
  "function getCurrentPrice(uint256 tokenId) view returns (uint256)",
  "function getRemainingTokens(uint256 tokenId) view returns (uint256)",
  "function calculatePurchaseCost(uint256 tokenId,uint256 tokenAmount) view returns (uint256 tokenCost,uint256 platformFee)",
  "function buyTokens(uint256 tokenId,uint256 amount)",
  "function balanceOf(address account,uint256 id) view returns (uint256)",
  "function getTotalSupply(uint256 tokenId) view returns (uint256)",
];

export const ERC20_ABI = [
  "function approve(address spender,uint256 amount) returns (bool)",
  "function allowance(address owner,address spender) view returns (uint256)",
  "function balanceOf(address owner) view returns (uint256)",
  "function decimals() view returns (uint8)",
  "function symbol() view returns (string)",
];

